import React from 'react';
import ReactDOM from 'react-dom';
import './i18n';
import './index.scss';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { ThemeProvider as LegacyThemeProvider } from '@material-ui/core/styles';
import theme, { FFTheme } from './assets/theme';
import legacyTheme from './assets/theme/legacyTheme';

import App from './App';
import * as serviceWorker from './serviceWorker';
import { MaterialUIControllerProvider } from './contexts/layoutContext';

ReactDOM.render(
  <ThemeProvider theme={theme as FFTheme}>
    {/* The v4 components get a theme too, from the same tokens, so both
        halves of the dashboard look alike. */}
    <LegacyThemeProvider theme={legacyTheme}>
      <MaterialUIControllerProvider>
        <CssBaseline />
        <App />
      </MaterialUIControllerProvider>
    </LegacyThemeProvider>
  </ThemeProvider>,
  // <React.StrictMode>
  // </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// import React from "react";
// import { createRoot } from "react-dom/client";
// import { BrowserRouter } from "react-router-dom";
// import App from "./V2/App";
// import { MaterialUIControllerProvider } from "./V2/context";

// const container = document.getElementById("root");
// if (container) {
//   const root = createRoot(container);
//   root.render(
//     <BrowserRouter>
//       <MaterialUIControllerProvider>
//         <App />
//       </MaterialUIControllerProvider>
//     </BrowserRouter>
//   );
// } else {
//   throw new Error("No root element found");
// }
